<script>
  export let change;

  const preChange = () => {
    if(!document.getElementById("chk").checked){
      document.getElementById("chk").checked = true;
      return;
    }
    change();
  };
</script>

<section class="content">
  <input
    class="inp-cbx"
    id="chk"
    type="checkbox"
    style="display: none"
    autocomplete="off"
    on:change="{preChange}"
  /><label class="cbx" for="chk"
    ><span style="transform: scale(1.6);"
      ><svg width="12px" height="10px">
        <use xlink:href="#check" />
      </svg></span
    ><span class="text">私はロボットです</span></label
  >
  <svg class="inline-svg">
    <symbol id="check" viewbox="0 0 12 10">
      <polyline points="1.5 6 4.5 9 10.5 1" />
    </symbol>
  </svg>
</section>

<style>
  * {
    box-sizing: border-box;
  }
  .cbx {
    -webkit-user-select: none;
    user-select: none;
    cursor: pointer;
    padding: 6px 8px;
    border-radius: 6px;
    overflow: hidden;
    transition: all 0.2s ease;

    display: flex;
    justify-content: center;
    align-items: center;
  }
  .cbx:not(:last-child) {
    margin-right: 6px;
  }
  .cbx span {
    float: left;
    vertical-align: middle;
    transform: translate3d(0, 0, 0);
  }
  .cbx span:first-child {
    position: relative;
    width: 18px;
    height: 18px;
    border-radius: 4px;
    transform: scale(1);
    border: 1px solid #cccfdb;
    transition: all 0.2s ease;
  }
  .cbx span:first-child svg {
    position: absolute;
    top: 3px;
    left: 2px;
    fill: none;
    stroke: rgb(0,158,85);
    stroke-width: 2;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-dasharray: 16px;
    stroke-dashoffset: 16px;
    transition: all 0.3s ease;
    transition-delay: 0.1s;
    transform: translate3d(0, 0, 0);
  }
  .cbx span:last-child {
    padding-left: 8px;
    line-height: 18px;
  }
  .cbx:hover span:first-child {
    border-color: #808080;
  }
  .inp-cbx {
    position: absolute;
    visibility: hidden;
  }
  .inp-cbx:checked + .cbx span:first-child {
    background: transparent;
    border-color: transparent;
    animation: wave 0.4s ease;
  }
  .inp-cbx:checked + .cbx span:first-child svg {
    stroke-dashoffset: 0;
  }
  .content {
    font-family: "Open Sans", sans-serif;
    font-size: 14px;
    -webkit-font-smoothing: antialiased;
    text-rendering: optimizelegibility;
    color: black;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .inline-svg {
    position: absolute;
    width: 0;
    height: 0;
    pointer-events: none;
    user-select: none;
  }
  @-moz-keyframes wave {
    50% {
      transform: scale(0.9);
    }
  }
  @-webkit-keyframes wave {
    50% {
      transform: scale(0.9);
    }
  }
  @-o-keyframes wave {
    50% {
      transform: scale(0.9);
    }
  }
  @keyframes wave {
    50% {
      transform: scale(0.9);
    }
  }

  .text {
    width: 152px;
    font-weight: 400;
    line-height: 17px;
    margin-left: 8px;
  }
</style>
